<template>
  <div>
    <div class="z-caption warning-title">
      Pagamento em aberto identificado
    </div>

    <p class="z-text spacer-bottom-m">
      Identificamos uma mensalidade em aberto com vencimento para hoje. Deseja efetuar o pagamento
      <span v-if="isBoleto">
        via boleto?
      </span>
      <span v-else-if="isPix">
        via Pix?
      </span>
      <span v-else>
        com o novo cartão?
      </span>
    </p>

    <div class="current-bill-info">
      <div class="current-bill-info__item">
        <span class="z-text z-text--bold">Mensalidade:</span>
        <span class="z-text">{{ bill.full_value | formatCurrency }}</span>
      </div>
      <div class="current-bill-info__item">
        <span class="z-text z-text--bold">Vencimento:</span>
        <span class="z-text">{{ dueDate }}</span>
      </div>
      <div class="current-bill-info__item">
        <span class="z-text z-text--bold">Pagamento:</span>
        <span class="z-text" v-if="isBoleto">
          Boleto
        </span>
        <span class="z-text" v-else-if="isPix">
          Pix
        </span>
        <span v-else>
          {{ cardType }} {{ card.card_brand | capitalize }} final {{ card.last_digits }}
        </span>
      </div>
    </div>

    <alert-box ref="alertBox" class="spacer-bottom-l" />

    <div class="z-button-wrapper">
      <button class="z-button z-button--primary z-button--block" @click="goToBoletoPage()" v-if="isBoleto">
        Gerar boleto
      </button>

      <button class="z-button z-button--primary z-button--block" @click="goToPixPage()" v-else-if="isPix">
        Gerar Pix
      </button>

      <button class="z-button z-button--primary z-button--block" @click="submitPayment()" v-else>
        Pagar agora
      </button>

      <button class="z-button z-button--block z-button--secondary" @click="goToHomePage()">
        Voltar para página inicial
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.warning-title {
  color: var(--color-support-warning-deep);
}

.current-bill-info {
  margin-bottom: var(--space-extra-large);
}

.current-bill-info__item {
  margin-bottom: var(--space-small);
  margin-right: var(--space-jumbo);
}
</style>

<script>
import AlertBox from 'components/zilla/alert-box';
import CardPaymentService from 'services/CardPaymentService';
import DateUtils from 'utils/date-utils';
import { mapState } from 'vuex';

export default {
  components: {
    AlertBox,
  },
  props: {
    bill: {
      type: Object,
      required: true,
    },
    card: {
      type: Object,
      default: (() => {}),
    },
  },
  computed: {
    ...mapState(['currentBilling']),
    dueDate() {
      return DateUtils.getFormattedDate(this.bill.due_date);
    },
    isBoleto() {
      return this.currentBilling.recurrent_payment_method === 'boleto';
    },
    isPix() {
      return this.currentBilling.recurrent_payment_method === 'pix';
    },
    cardType() {
      return `Cartão de ${this.card.card_type === 'credit_card' ? 'crédito' : 'débito'}`;
    },
  },
  methods: {
    submitPayment() {
      this.$pageLoader.show('Processando pagamento');

      CardPaymentService.charge(this.currentBilling.id, this.bill.id, this.card.id)
        .then((response) => {
          this.treatResponse(response);
        })
        .catch(() => {
          this.showUnexpectedErrorMessage();
        })
        .finally(() => this.$pageLoader.hide());

      this.$tracker.logEvent(
        'Clicked "Pagar agora" in payment method successfully changed page',
        {
          cardType: this.card.card_type,
        },
      );
    },
    treatResponse(response) {
      if (response.data.status === 'paid') {
        this.treatPaidBill();
      } else if (response.data.status === 'refused') {
        this.treatRefusedBill(response.data.postback_message);
      } else {
        this.showUnexpectedErrorMessage();
      }
    },
    treatPaidBill() {
      this.$router.replace({
        name: 'bill-payment-success',
        params: { billId: this.bill.id },
      });
    },
    treatRefusedBill(refusalMessage) {
      this.$refs.alertBox.show(
        'danger', 'Pagamento recusado',
        refusalMessage || 'Não foi possível efetuar o pagamento com o cartão selecionado. Utilize outro cartão.',
      );
    },
    showUnexpectedErrorMessage() {
      this.$refs.alertBox.show(
        'danger', 'Erro inesperado',
        'Não foi possível efetuar o pagamento. Tente novamente mais tarde ou entre em contato com o Quero Pago.',
      );
    },
    goToHomePage() {
      this.$tracker.logEvent('Clicked "Voltar para página inicial" in payment method successfully changed page');
      this.$router.push({ name: 'panel' });
    },
    goToBoletoPage() {
      this.$tracker.logEvent('Clicked "Gerar boleto" in payment method successfully changed page');
      this.$router.push({ name: 'bill-boleto', params: { billId: this.bill.id } });
    },
    goToPixPage() {
      this.$tracker.logEvent('Clicked "Gerar Pix" in payment method successfully changed page');
      this.$router.push({ name: 'nb-pix', params: { billId: this.bill.id } });
    },
  },
};
</script>
